<template>

    <div class="page">

        <div class="page-content bottom-sp60">
                
            <div style="height: 100px" class="hidden-xs hidden-md"></div>

            <a class="link back" style="position: absolute; top: 17px; left: 30px;">
                <i class="las la-bars" v-on:click="$root.menu" style="font-size: 26px; color: #444"></i>
            </a>
            
            <div class="container">
                <center class="hidden-xl hidden-lg">
                    <img src="static/images/logo3.png" style="width: 60%; margin-top: 30px; margin-bottom: 20px;">
                </center>
            </div>
          

            <div class="container">

                <div v-if="$root.user.tipo == 'prestador'">
                    <h5 v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 10px;">
                        <i class="las la-exclamation-triangle"></i>
                        Você precisa cadastrar sua conta bancária para começar a trabalhar.
                    </h5>
<!-- 
                    <h5 v-if="$root.user.confirmacao == 1 && $root.user.pagamentoId && $root.user.disponibilidade.length == 0" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 10px;">
                        <i class="las la-exclamation-triangle"></i>
                        Você precisa definir seu <b>horário de atendimento</b> para ficar disponível para vendas no aplicativo.
                    </h5>                     -->

                    <h5 v-if="$root.user.confirmacao == 0" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                        <i class="las la-exclamation-triangle"></i>
                        Seu <b style="font-weight: 600;">cadastro está em análise</b> pela nossa equipe. Você <b style="font-weight: 600;">receberá</b> uma <b style="font-weight: 600;">notificação</b> quando tudo estiver pronto para começar a <b style="font-weight: 600;">trabalhar</b>.
                    </h5>
                    <h5  v-if="$root.user.confirmacao == -1" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                        <i class="las la-exclamation-triangle"></i>
                        Infelizmente seu cadastro foi negado pela nossa equipe. Entre em contato caso tenha dúvidas.
                    </h5>      

<!--                     <button v-if="$root.user.confirmacao == 1 && ($root.user.entregaDelivery == 1 || $root.user.entregaRetirar == 1) && $root.user.pagamentoId && $root.user.disponibilidade.length == 0" v-on:click="$root.go('HorarioAtendimento', JSON.stringify({'tutorial': true}))" type="button" class="button button-fill button-large color-green block-mobile " style="margin-bottom: 28px">
                        <i class="las la-clock"></i>
                        Definir horário de atendimento
                    </button>
 -->
                    <button v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" v-on:click="$root.go('Carteira')" type="button" class="button button-fill button-large color-green block-mobile " style="margin-bottom: 28px">
                        <i class="las la-money-bill-wave"></i>
                        Cadastrar dados bancários
                    </button>                                                                
                </div>

                <div class="title-bar" v-if="$root.user.tipo == 'prestador'">
                    <h5 class="dz-title">Área do profissional</h5>
                </div>
            </div>


            <div class="container hidden-xs hidden-md">

                <div class="hidden-xl hidden-lg" v-bind:class="{'disabled': $root.user.confirmacao != 1}" v-if="$root.user.tipo == 'prestador'" style="margin-top: 15px; margin-bottom: 25px; position: relative; width: 100%; max-width: 100%;">
                    <div class="badge-lg" style="background: #064972 !important; display: block !important;  padding: 20px">
                        <center>
                            <p style="margin: 0px; color: #fff;  font-size: 18px; display: block; width: 100%;">
                                <i class="las la-money-bill" style="font-size: 20px; color: #fff;"></i>
                                Carteira digital
                                <!-- &nbsp;&nbsp; -->
                                <!-- <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b> -->
                            </p>
                            <h1 style="color: #fff; margin: 0px; display: block; width: 100%;">
                                <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b>
                            </h1>
                            <p style="margin: 0px; color: #fff;  font-size: 14px; display: block; width: 100%;">
                                Saldo a liberar:&nbsp;&nbsp;<b>R$ {{saldo.AmountPreviewTotal | toMoney }}</b>
                            </p>   

                            <div style="height: 1px; width: 100%; display: block;">
                                
                            </div>

                            <button v-bind:class="{'disabled': saldo.AmountAvailableToday == 0}" v-on:click="sacar()" class="button-outline button color-white" style="display: inline-block; width: auto; margin-top: 5px; margin-bottom: 5px;">
                            <!-- <button v-on:click="sacar()" class="button-outline button color-white" style="display: inline-block; width: auto; margin-top: 5px; margin-bottom: 5px;"> -->
                                Sacar valor disponível
                            </button>                                                                 

                            <a v-on:click="$root.go('Saques')" style="text-decoration: underline; color: #fff; font-size: 12px; display: block; margin-top: 0px; opacity: 0.7;">Extrato de recebimentos e saques</a>
                        </center>
                    </div>                                
                </div>

            </div>


            <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init mb-20 user-swiper" style=" padding-right: 30px" v-if="$root.user.tipo == 'prestador'" v-bind:class="{'disabled': ($root.user.confirmacao != 1 || !$root.user.pagamentoId)}">
                <div class="swiper-wrapper" style="">
                    <div class="swiper-slide" style="width: 130px; margin-left: 30px;" v-on:click="$root.go('Agendas', JSON.stringify({'voltar': true, 't': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-cog" style="font-size: 40px; color: #FFF;"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Opções de<br>atendimento</a></h6>
                        </div>
                    </div>         
                    <div class="swiper-slide" style="width: 130px; " v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-clock" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Horários agendados</a></h6>
                        </div>
                    </div>
                    <div class="swiper-slide" style="width: 130px;" v-on:click="$root.go('Informacoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-file-alt" style="font-size: 40px; color: #FFF;"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Informações gerenciais</a></h6>
                        </div>
                    </div>   
                    <div class="swiper-slide" style="width: 130px;" v-on:click="$root.go('Cupons', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-gift" style="font-size: 40px; color: #FFF;"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Cupons de desconto</a></h6>
                        </div>
                    </div>    
                    <div class="swiper-slide" style="width: 130px;" v-on:click="$root.go('Carteira', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-money-bill" style="font-size: 40px; color: #FFF;"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Dados bancários</a></h6>
                        </div>
                    </div>                                                               
                    <div class="swiper-slide" style="width: 130px;" v-on:click="$root.go('Contato')">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-sms" style="font-size: 40px; color: #FFF;"></i>
                            <h6 class="title" ><a style="color: #FFF; font-size: 14px">Fale<br>conosco</a></h6>
                        </div>
                    </div>                                                                                                                                                       
                </div>
            </div>


            <div class="container">

                <div class="hidden-xl hidden-lg" v-bind:class="{'disabled': $root.user.confirmacao != 1}" v-if="$root.user.tipo == 'prestador'" style="margin-top: 15px; margin-bottom: 25px; position: relative; width: 100%; max-width: 100%;">
                    <div class="badge-lg" style="background: #064972 !important; display: block !important;  padding: 20px">
                        <center>
                            <p style="margin: 0px; color: #fff;  font-size: 18px; display: block; width: 100%;">
                                <i class="las la-money-bill" style="font-size: 20px; color: #fff;"></i>
                                Carteira digital
                                <!-- &nbsp;&nbsp; -->
                                <!-- <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b> -->
                            </p>
                            <h1 style="color: #fff; margin: 0px; display: block; width: 100%;">
                                <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b>
                            </h1>
                            <p style="margin: 0px; color: #fff;  font-size: 14px; display: block; width: 100%;">
                                Saldo a liberar:&nbsp;&nbsp;<b>R$ {{saldo.AmountPreviewTotal | toMoney }}</b>
                            </p>   

                            <div style="height: 1px; width: 100%; display: block;">
                                
                            </div>

                            <button v-bind:class="{'disabled': saldo.AmountAvailableToday == 0}" v-on:click="sacar()" class="button-outline button color-white" style="display: inline-block; width: auto; margin-top: 5px; margin-bottom: 5px;">
                            <!-- <button v-on:click="sacar()" class="button-outline button color-white" style="display: inline-block; width: auto; margin-top: 5px; margin-bottom: 5px;"> -->
                                Sacar valor disponível
                            </button>                                                                 

                            <a v-on:click="$root.go('Saques')" style="text-decoration: underline; color: #fff; font-size: 12px; display: block; margin-top: 0px; opacity: 0.7;">Extrato de recebimentos e saques</a>
                        </center>
                    </div>                                
                </div>

                <!-- </div> -->
                <div class="title-bar" v-if="$root.user.tipo == 'admin'">
                    <h5 class="dz-title">Área de administração</h5>
                </div>
            </div>

            <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init mb-30 user-swiper" style=" padding-right: 30px" v-if="$root.user.tipo == 'admin'">
                <div class="swiper-wrapper" style="">
                    <div class="swiper-slide" style="width: 147px; margin-left: 30px;" v-on:click="$root.go('Usuarios')">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-user-check" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Usuários</a></h6>
                        </div>
                    </div>
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-clock" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Agendamentos</a></h6>
                        </div>
                    </div>                 
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Configuracoes')">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-cog" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Configurações</a></h6>
                        </div>
                    </div>
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Profissoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-stethoscope" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Profissões</a></h6>
                        </div>
                    </div>                    
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Especialidades', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-briefcase-medical" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Especialidades</a></h6>
                        </div>
                    </div>
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Avaliacoes')">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="lar la-star" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Avaliações</a></h6>
                        </div>
                    </div>                    
                    <div class="swiper-slide" style="width: 147px;" v-on:click="$root.go('Cupons')">
                        <div class="categories-bx" style="padding-bottom: 15px;">
                            <i class="las la-gift" style="font-size: 40px; color: #FFF"></i>
                            <h6 class="title" ><a style="color: #FFF">Cupons</a></h6>
                        </div>
                    </div>                            
                                    
                </div>
            </div>                


            <div v-if="$root.user.tipo != 'prestador'" style="background: #f7f7f7; padding-left: 30px; padding-right: 30px; margin-bottom: 0px; padding-top: 20px; padding-bottom: 5px;">
                
                <div class="title-bar">
                    <h5 class="dz-title">O que você deseja?</h5>
                </div>

                <div data-space-between="20" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init mb-30 user-swiper" style=" padding-right: 30px; margin-left: -30px; margin-right: -30px;">
                    <div class="swiper-wrapper" style="padding-left: 30px; padding-right: 30px;">

                        <div v-for="(item, index) in categorias.itens" :key="item.cod" v-on:click="item.tipo == 'profissao' ? $root.go('Busca', JSON.stringify({'profissao': item.cod})) : $root.go('Busca', JSON.stringify({'especialidade': item.cod}))" class="swiper-slide" style="width: 147px;" >
                            <div class="categories-bx" style="padding-bottom: 15px; min-height: 50px; display: flex; flex-direction: row; align-content: center; align-items: center;">
                                <h6 class="title" style="text-align: center; width: 100%;"><a style="color: #FFF; font-size: 14px">{{item.nome}}</a></h6>
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>

            <div data-space-between="10" data-slides-per-view="auto" data-centered-slides="false" class="swiper-container swiper-init mb-30 mt-30 galeria-swiper hidden-xs" style=" padding-right: 30px">
                <div class="swiper-wrapper" style="">

                    <div v-show="$root.user.tipo != 'admin'" class="swiper-slide" style="width: 1px; margin-left: 25px;"></div>
                    <div v-show="$root.user.tipo == 'admin'" class="swiper-slide add" style="width: 147px; margin-left: 30px;">
                        <div class="banner" style="">
                            <div class="uploadButton">
                                <input class="uploadButton-input" type="file" name="imagem" multiple="" @change="getBase64Imagem" accept="image/*" id="upload-imagem" />
                                <label class="uploadButton-button" for="upload-imagem">
                                    <span>
                                        <i class="las la-plus"></i>
                                        ADICIONAR<br>BANNER
                                    </span>
                                </label>
                            </div>                            
                        </div>
                    </div>    

                    <div class="swiper-slide" style="width: 147px;" v-for="(item, index) in galeria.itens" :key="item.cod">
                        <div class="banner" :style="{'background-image': 'url(' + $root.config.url + '/' + item.imagem + ')'}">  
                            <a v-if="$root.user.tipo == 'admin'" v-on:click.stop.prevent="delGaleria(item.cod)" class="button button-fill color-red">
                                <i class="las la-trash"></i>
                            </a>
                        </div>
                    </div>                                 
                </div>
            </div>
        </div>
        
        <Toolbar></Toolbar>
        
    </div>
</template>

<script>
import Top      from './Top'
import Toolbar  from './Toolbar'
var self = this;
export default {
    name: 'Inicio',
    components: {
        'Top':                      Top,
        'Toolbar':                  Toolbar
    },        
    data () {
        return {
            "filtro":               false,
            "saldo": {
                "AmountAvailableToday":0,
                "AmountPreviewTotal": 0
            },                   
            "categorias": {
                "itens":            []
            },
            "galeria": {
                "itens":            []
            },    
            "data": {
                "itens":            []
            },                        
            "form": {
                "tipo":             "catalogo",
                "page":             1,
                "distancia":        "",
                "profissao":        "",
                "especialidade":    "",
                "servico":          "",
                "tipo":             "",
                "pesquisa":         ""
            },
            "formBanner": {
                // "_cod":             self.$root.user.cod,
                // "_token":           self.$root.user.token,
                "imagem":           ""
            }            
        }
    },
    filters: {     
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
            // return value.toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },     
    methods: {
        delGaleria: function(cod) {
            console.log("delGaleria()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/galeria.php", {params: form})
                .then(response => {
                    console.log("delGaleria() response", response)
                    self.getGaleria().finally(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("delGaleria() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },       
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 800, Infinity, 0.6, blob => {
                    blobToBase64(blob, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.formBanner.imagem  = result;
                        self.submitBanner();                        
                    });
                }); 
            } else {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            } 
        },      
        submitBanner: function() {
            var self            = this;
            loading.show();

            self.formBanner._cod      = self.$root.user.cod;
            self.formBanner._token    = self.$root.user.token;

            axios.post("api/galeria.php", self.formBanner)
            .then(response => {
                console.log("submitBanner() response", response);
                self.getGaleria().finally(function() {
                    loading.hide();
                });
            })
            .catch(error => {
                console.log("submitBanner() error", error);
                loading.hide();                 
                alert(error.response.data ? error.response.data.message : "Erro! Por favor, tente novamente.");
            });

        },              
        mostrarFiltro: function() {
            var self = this;
            self.filtro = (self.filtro ? false : true);
            self.$forceUpdate();
        },
        sacar: function() {
            var self    = this;

            var form            = {};
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.acao           = "sacar";
            loading.show();
            
            axios.put("api/carteira.php", form)
            .then(response => {
                console.log("renovar() responde", response.data);
                alert(response.data.message);
                self.getSaldo().finally(function() {
                    loading.hide();
                });
            })
            .catch(error => {
                console.log("renovar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                
            });  
        },          
        getSaldo: function() {
            // console.log("getSaldo()");
            var self = this;
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "prestador") {
                    return resolve(true);
                }

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.tipo           = "saldo";

                axios.get("api/carteira.php", {"params": form})
                .then(response => {
                    
                    console.log("getSaldo() response", response);
                    self.saldo      = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getSaldo() error", error);

                    resolve(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                }); 
            }); 

        },            
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        // "filtro":       "destaque"
                    }
                };

                if (self.$root.cache.categorias.data) {
                    self.categorias   = JSON.parse(JSON.stringify(self.$root.cache.categorias.data));
                    resolve(self.categorias);
                    
                } else {
                    
                    axios.get("api/categorias.php", form)
                    .then(response => {
                        
                        console.log("getCategorias() response", response);
                        self.categorias                     = response.data.result;

                        setTimeout(function() {
                            var swiper = new Swiper('.categories-swiper', $(".categories-swiper").data());
                        }, 100);

                        self.$root.cache.categorias.data    = JSON.parse(JSON.stringify(response.data.result));
                        // loading.hide();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getCategorias() error", error);                    
                        // loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        if (error.response) {
                            if (error.response.status == 404) {
                                self.$root.back();
                            }
                        }                    
                    });   
                }
            });   
        },   
        getGaleria: function() {
            var self        = this;
            console.log("getGaleria()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/galeria.php", form)
                .then(response => {
                    
                    console.log("getGaleria() response", response);
                    self.galeria                     = response.data.result;
                    // self.$root.cache.inicioPrestadores.data    = JSON.parse(JSON.stringify(response.data.result));
                    // loading.hide();

                    self.$forceUpdate();

                    setTimeout(function() {
                        var swiper = new Swiper('.galeria-swiper', $(".galeria-swiper").data());
                    }, 500);                    
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getGaleria() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                    
                });   

            });   
        },                       
        get: function(load) {
            var self        = this;
            
            console.log("get()", self.form, load);
            self.$root.go("Busca", JSON.stringify({
                "pesquisa":         self.form.pesquisa, 
                "profissao":        self.form.profissao, 
                "distancia":        self.form.distancia, 
                "tipo":             self.form.tipo, 
                "especialidade":    self.form.especialidade, 
            }));

        },          
    },
    created: function() {
        loading.show();
        var self = this;

        if (!window.__app.mobile.isMobile) {
            self.$root.go("Conta");
            return false;
        }
    },
    activated: function() {
        var self = this;
        var load = true;

        self.$root.cache.catalogo = {
            "filtro":   null,
            "data":     null,
        };

        self.$root.$forceUpdate();

        if (!self.$root.cache.inicioCatalogo.filtro) {
            self.$root.cache.inicioCatalogo.filtro = JSON.parse(JSON.stringify(self.form));
        } else {
            console.log("Possui cache filtro", self.$root.cache.inicioCatalogo);
            self.form   = JSON.parse(JSON.stringify(self.$root.cache.inicioCatalogo.filtro));
        }
        if (self.$root.cache.inicioCatalogo.data) {
            self.data   = JSON.parse(JSON.stringify(self.$root.cache.inicioCatalogo.data));
            self.loaded = true;
            load        = false;

            console.log("Ja tem os itens do catalogo em cache", self.data)
        }         
        loading.show();
        Promise.resolve()
        .then(self.getCategorias())
        .then(self.getGaleria())
        .then(self.getSaldo())
        .finally(function() {

            console.log("Buscou tudo")
            setTimeout(function() {
                self.$forceUpdate();
                self.$root.$forceUpdate();
                setTimeout(function() {
                    loading.hide();
                }, 1000);
            }, 500);

        });
    },
    mounted: function() {
        var self = this;
        setTimeout(function() {
            if ($(".user-swiper").length > 0) {
                var swiper = new Swiper('.user-swiper', $(".user-swiper").data());
            }
            var swiper = new Swiper('.categories-swiper', $(".categories-swiper").data());
            var swiper = new Swiper('.pro-swiper', $(".pro-swiper").data());
            var swiper = new Swiper('.catalogo-swiper', $(".catalogo-swiper").data());
        }, 500);
        setTimeout(function() {
            // loading.hide();
            // self.$root.go("Conta");
        }, 1000);
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">

    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        font-weight: 500;
        margin-bottom: 0px !important;
        line-height: 130%;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
        padding-bottom: 0px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .avatar-empresa {
        margin: 0px !important;
        /*width: 100px;*/
    }

    .pro-swiper .dz-info {
        width: 100%;
    }

    .pro-swiper .dz-meta {
        margin-top: 0px;
    }

    .avatar-empresa img {
        float: right;
        width: 100px;
        border-radius: 10px;
        /*border: 1px solid #ddd;*/
    }

    .banner {
        width: 100%;
        height: 147px;
        background-color: #efefef;
        border-radius: 10px;
        line-height: 150px;
        vertical-align: middle;
        text-align: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border: 1px solid #efefef;
    }

    .swiper-slide.add {
        /*margin-right: -10px !important;*/
    }

    .swiper-slide.add span {
        line-height: 130%;
        display: inline-block;
        position: relative;
        top: 10px;
        color: #333;
        font-weight: bold;        
    }

    .banner .uploadButton {
        width: 100%;
        height: 100%;
    }

    .banner .uploadButton label {
        width: 100%;
        height: 100%;
    }    

    .banner .uploadButton-input {
        visibility: hidden;
        position: absolute;
        left: -99999999px;
    }    

    .banner .button i {
        margin: 0px !important;
    }

    .banner .button {
        position: absolute;
        right: 10px;
        padding: 0px;
        text-align: center;
        font-size: 20px;
        top: 10px;
        width: 25px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue